import React, { createContext, useContext, useRef } from 'react';
import { getShellThemeFromStorage } from 'utils/sidebarShellTheme';

const NotificationContext = createContext();

const getNotificationIcon = (type) => {
  if (type === 'success') {
    return 'tim-icons icon-check-2';
  }
  if (type === 'danger' && getShellThemeFromStorage() === '2') {
    return 'tim-icons icon-alert-circle-exc';
  }
  return 'tim-icons icon-bell-55';
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children, notificationAlertRef }) => {
  const showNotification = (type, message) => {
    if (notificationAlertRef && notificationAlertRef.current) {
      const options = {
        place: "tr", // top-right
        message: message,
        marginTop: "100px",
        type: type, // success, danger, warning, info, primary
        icon: getNotificationIcon(type),
        autoDismiss: type === "success" ? 3 : 5, // Success alerts close in 3 seconds, others in 5
      };
      notificationAlertRef.current.notificationAlert(options);
    } else {
    }
  };

  return (
    <NotificationContext.Provider style={{marginTop: "100px"}} value={{ showNotification }}>
      {children}
    </NotificationContext.Provider>
  );
}; 